export default {
  TENANTS: 'tenants',
  EXTERNAL_IDP_OIDC: 'external_idp_oidc',
  EXTERNAL_IDP_SAML: 'external_idp_saml',
  PRODUCT_INSTANCES: 'product_instances',
  USERS: 'users'
};
